import { H3 } from "../Text";
import * as dayjs from "dayjs";
import { validateArray } from "../../utils/validate";

const TableComplete = (props) => {
  const {
    header,
    data,
    call,
    onClick = () => { },
    height,
    subList,
    buttons,
  } = props;
  return (
    <div
      style={{
        maxHeight: height === null ? "" : `${height}px`,
      }}
      className="mx-auto overflow-scroll"
    >
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-base text-[#1d4ed8]">
          <tr>
            {validateArray(header)
              ? header.map((head, index) => (
                <th
                  key={index}
                  scope="col"
                  className={`${index === 0 ? "sticky z-0 left-0" : ""
                    } py-3 px-6 bg-[#f1f5f9] ${
                    // head.type === 'action'?
                    head.sticky ? "sticky right-0 px-4" : ""
                    // : ''
                    }`}
                >
                  {head.label}
                </th>
              ))
              : null}
          </tr>
        </thead>
        <tbody>
          {validateArray(data)
            ? data.map((item, index) =>
              subList ? (
                item[subList].map((subItem, j) => {
                  return (
                    <ContainTable
                      key={j}
                      call={call}
                      // item={{ ...subItem, ...item }}
                      item={subItem}
                      header={header}
                      onClick={onClick}
                      buttons={buttons}
                    />
                  );
                })
              ) : (
                <ContainTable
                  key={index}
                  call={call}
                  item={item}
                  header={header}
                  onClick={onClick}
                  buttons={buttons}
                />
              ),
            )
            : null}
        </tbody>
      </table>
      {!validateArray(data) && (
        <H3 className="text-center text-gray-500 my-2">La lista esta vacía</H3>
      )}
    </div>
  );
};
const ContainTable = (props) => {
  const { item, header, onClick, call, buttons } = props;
  return (
    <tr className="bg-white border-b">
      {validateArray(header)
        ? header.map((head, j) =>
          j === 0 ? (
            <th
              key={j}
              scope="row"
              onClick={() => onClick(item, call)}
              className="sticky left-0 py-4 px-6 font-medium text-gray-900 bg-[#fcfcfc]"
            >
              <DataType
                value={item[head.name]}
                head={head}
                data={item}
                call={call}
              />
            </th>
          ) : head.type !== "action" ? (
            <td
              key={j}
              className={`${head.sticky ? "sticky right-0 bg-[#f7f7f7]" : "py-2 px-1"
                }`}
              onClick={
                head.disabledOnClick ? () => { } : () => onClick(item, call)
              }
            >
              <DataType
                value={item[head.name]}
                head={head}
                data={item}
                call={call}
                buttons={buttons}
              />
            </td>
          ) : (
            <td
              key={j}
              className={`${head.sticky ? "sticky right-0 bg-[#f7f7f7]" : ""
                }`}
            >
              {validateArray(head.actions) ? (
                <div
                  className={
                    head.groupActions
                      ? `mx-auto flex flex-wrap items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white/80 p-1 ${head.actionGroupClassName || "max-w-[132px]"}`
                      : "grid grid-flow-col grid-rows-2 gap-x-4 gap-y-2"
                  }
                >
                  {head.actions.map((act, index) => {
                    const isHidden = typeof act?.hidden === "function" ? act.hidden(item) : act?.hidden;

                    return act && act.action && !isHidden ? (
                      <div
                        key={index}
                        // className={`${act.color} text-xl cursor-pointer`}
                        className={
                          head.groupActions
                            ? `${act.color} ${act.bgColor || "bg-white"} ${act.borderColor || "border-slate-200"} inline-flex h-8 w-8 items-center justify-center rounded-md border text-base shadow-sm transition ease-in-out hover:-translate-y-0.5 hover:scale-105 cursor-pointer ${act.validate
                              ? item.showButtonJoinPdfs
                                ? ""
                                : "hidden"
                              : ""
                              }`
                            : `${act.color} text-xl cursor-pointer ${act.validate
                              ? item.showButtonJoinPdfs
                                ? ""
                                : "hidden"
                              : ""
                              }`
                        }
                        onClick={(event) => {
                          event.stopPropagation();
                          act.action(item, call);
                        }}
                        title={act.label}
                      >
                        <span aria-hidden="true" className={act.icon}></span>
                      </div>
                    ) : null;
                  })}
                </div>
              ) : null}
            </td>
          ),
        )
        : null}
    </tr>
  );
};

const DataType = (props) => {
  const { value, head, data, call, buttons } = props;

  function validateType() {
    const listData = {
      date:
        value === "0001-01-01T00:00:00" || value === null
          ? "-"
          : dayjs(value).format("DD/MM/YYYY HH:mm"),
      custom: head.builder
        ? head.builder(value, head, data, call, buttons)
        : null,
      translate: head.translate ? head.translate[value] : "",
      // badgePlazoDam: (() => {
      //   const stringValue = value ? String(value) : "";
      //   const match = stringValue.match(/^(\d+)\.(\d{2}):(\d{2}):(\d{2})$/);

      //   if (!match) {
      //     return (
      //       <span
      //         title={`dias = ${0}`}
      //         className="mx-auto block w-fit whitespace-nowrap border-[1.35px] border-gray-500 bg-gray-400/40 text-gray-800 text-xs font-medium py-[2px] px-2 rounded-md"
      //       >
      //         Indefinido
      //       </span>
      //     );
      //   }

      //   const [_, days, hours, minutes] = match;
      //   const totalDays = parseInt(days, 10);

      //   const formattedTime = [
      //     parseInt(days) > 0 ? `${days} día${days > 1 ? "s" : ""}` : "",
      //     parseInt(hours) > 0 ? `${hours}h` : "",
      //     parseInt(minutes) > 0 ? `${minutes}min` : "",
      //   ]
      //     .filter(Boolean)
      //     .join(", ");
      //   const formattedTitle = `Hace ${formattedTime}`;

      //   if (totalDays <= 20) {
      //     return (
      //       <span
      //         title={formattedTitle}
      //         className="mx-auto block w-fit whitespace-nowrap border-[1.35px] border-green-500 bg-green-400/40 text-green-800 text-xs font-medium py-[2px] px-2 rounded-md"
      //       >
      //         A plazo {`(${totalDays ?? 0} días)`}
      //       </span>
      //     );
      //   }

      //   return (
      //     <span
      //       title={formattedTitle}
      //       className="mx-auto block w-fit whitespace-nowrap border-[1.35px] border-red-500 bg-red-400/40 text-red-800 text-xs font-medium py-[2px] px-2 rounded-md"
      //     >
      //       Fuera de plazo {`(${totalDays ?? 0} días)`}
      //     </span>
      //   );
      // })(),
      // badgeStatusPayment: (() => {
      //   const valStatusPayment =
      //     value?.toLowerCase() === "cancelado" ? "Total Pagado" : "Pendiente";

      //   return (
      //     <>
      //       <span
      //         title={valStatusPayment}
      //         className={`
      //           mx-auto block w-fit whitespace-nowrap border-[1.35px]
      //           text-xs font-medium py-[2px] px-2 rounded-md
      //           ${
      //             valStatusPayment === "Total Pagado"
      //               ? "border-green-500 bg-green-400/40 text-green-800"
      //               : "border-yellow-500 bg-yellow-400/40 text-yellow-800"
      //           }
      //         `}
      //       >
      //         {valStatusPayment}
      //       </span>
      //     </>
      //   );
      // })(),
      // action: validateArray(head.actions) ? (
      //   <div className="flex gap-4 justify-center portrait:justify-end">
      //     {head.actions.map((act, index) => (
      //       <Tooltip
      //         key={index}
      //         title={act.label}
      //         position="left"
      //         trigger="mouseenter"
      //         className="w-full"
      //       >
      //         <div
      //           className={`${act.color} text-xl cursor-pointer transition ease-in-out hover:-translate-x-1 duration-200`}
      //           // onClick={() => act.action(value, call)}
      //         >
      //           <i className={`${act.icon}`}></i>
      //         </div>
      //       </Tooltip>
      //     ))}
      //   </div>
      // ) : null,
    };
    return listData[head.type] || value;
  }
  return <div>{validateType()}</div>;
};

export default TableComplete;
